import { render } from "./WAlert.vue?vue&type=template&id=61c20024&ts=true"
import script from "./WAlert.vue?vue&type=script&lang=ts"
export * from "./WAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__